import { collection, addDoc, query, where, getDocs, setDoc, orderBy, doc, updateDoc, deleteDoc, getDoc } from "firebase/firestore";
import { schedule_path, appointment_path, uid } from "./login"
import { db } from "./firebase"
import { store } from "../store"


function removeHyphens(str) {
    return str.replace(/-/g, '');
}

/**
 *  Creates new appointment
 * @param {object} apt - Appointment object containing diagnosis, cr, patientType, aptType, endTime, travel, aptLength, date, code, uniqueAppointmentId
 * @returns {void} Nothing is returned
 */
 export async function setSchedule(data, date, userId=uid) {
    debugger
    let schedule_data = await data;
    let parsedData = JSON.parse(schedule_data.result);

    const scheduleCollection = collection(db, `/physicians/${userId}/schedule`);
    for (const item of parsedData) {
        try {
        const docRef = await addDoc(scheduleCollection, {
            time: item.Time.trim(), //ok
            name: item.Patient.trim(),
            cr: item.CRNumber.trim(),
            aptType: removeHyphens(item.ApptType.trim().toLowerCase()),
            // HomePhone: item.HomePhone.trim(),
            dateOfBirth: item.DOB.trim(),
            OHIN: item.OHIN.trim(),
            diagnosis: item.Diagnosis.trim(),
            // Notes: item.Notes.trim(), // Assuming Notes is always a string
            date: date, // same function as ClassDefinitions.ts
            uniqueScheduleId: null,
            noShow: null,
            billed: false,
        });

        await updateDoc(docRef, {
            uniqueScheduleId: docRef.id
        });
        console.log(docRef.id)


        const appointment_temp = await setDoc(doc(db, `/physicians/${userId}/appointments`, docRef.id), {
            diagnosis: item.Diagnosis.trim(),
            cr: item.CRNumber.trim(),
            patientType: null,
            aptType: removeHyphens(item.ApptType.trim().toLowerCase()),
            endTime: null,
            billingTime: null,
            length: null,
            date: date,
            codes: [],
            wasAssessedForHospitalAdmission: null,
            userSubmittiedCustomCodes: null,
            patientName: item.Patient.trim(),
            seenAnotherDoctor: null,
            uniqueAppointmentId: docRef.id,
            registrationTime: (new Date).getTime(),
            specialVisit: null,
            firstPersonSeen: null,
            performedTravel: null,
            sacrificeOfOfficeHours: null,
            uniquePatientId: null,
            noShow: null,
        })
        console.log("Document written with ID: ", docRef.id);
        
        } catch (e) {
        console.error("Error adding document: ", e);
        }
    }
    store.aptDone = true;
}



export async function getSchedule(date=(new Date((new Date).getTime() - 4 * 60 * 60 * 1000)).toISOString().split('T')[0]){
    const scheduleCollection = query(collection(db, schedule_path), where("date", "==", date));
    const querySnapshot = await getDocs(scheduleCollection);
    let appointmentList = []
    querySnapshot.forEach((doc) => {
        appointmentList.push(doc.data())
    });

    // Function to convert time string to a comparable format
    const convertTime = (timeStr) => {
        let [time, modifier] = timeStr.split(/(am|pm)/i);
        let [hours, minutes] = time.split(':');
        hours = parseInt(hours);
        minutes = minutes ? parseInt(minutes) : 0;

        // Convert 12-hour time format to 24-hour time format
        if (modifier.toLowerCase() === 'pm' && hours < 12) {
            hours += 12;
        } else if (modifier.toLowerCase() === 'am' && hours === 12) {
            hours = 0;
        }

        return hours * 60 + minutes; // Return total minutes
    };

    // Sort the appointments based on converted time
    appointmentList.sort((a, b) => convertTime(a.time) - convertTime(b.time));

    return appointmentList;
}



/**
 * Returns the schedule object that matches a given uniqueID
 * @param {string} uniqueId - Schedule Unique ID
 * @returns {object} - All the schedule information contained in an object
 */
 export async function getScheduleByID(uniqueId){
    try {
        const scheduleRef = doc(db, schedule_path, uniqueId); // Replace "schedule_path" with your actual path
        const docSnapshot = await getDoc(scheduleRef);

        if (docSnapshot.exists()) {
            return docSnapshot.data(); // Returns the data if the document exists
        } else {
            console.log("No schedule found for ID:", uniqueId);
            return null; 
        }
    } catch (error) {
        console.error(`Error occurred in getScheduleByID: ${error}`);
        throw error; 
    }
}


export async function hasScheduleBeenSubmitted(physicianUid, date){
    const scheduleCollection = query(collection(db, `physicians/${physicianUid}/schedule`), where("date", "==", date));
    const querySnapshot = await getDocs(scheduleCollection);
    let appointmentList = []
    querySnapshot.forEach((doc) => {
        appointmentList.push(doc.data())
    });
    return appointmentList.length > 0;
}
